import { FacilityType } from '@/types/booking.types';
import { CHECK_IN_WINDOW_MS } from '@/constants/timings';

/**
 * How early check-in opens for a booking.
 *
 * The API owns this — every booking carries `checkInWindowMinutes`
 * resolved from `api/src/modules/bookings/config/check-in-window.ts`,
 * so the number can change server-side without an app release.
 *
 * The map below is only a fallback for a response that predates the
 * field (a cached list, an older API). Keep it in step with the
 * server config; the server is what actually decides.
 */
const FALLBACK_WINDOW_MS_BY_FACILITY: Partial<Record<string, number>> = {
  [FacilityType.RECOVERY_ROOM]: 5 * 60 * 1000,
  [FacilityType.CONFERENCE_ROOM]: 5 * 60 * 1000,
  [FacilityType.WORKSPACE]: 5 * 60 * 1000,
  [FacilityType.SAUNA]: 5 * 60 * 1000,
  [FacilityType.SHOWER]: 5 * 60 * 1000,
  [FacilityType.MASSAGE_CHAIR]: 5 * 60 * 1000,
};

export const getCheckInWindowMs = (booking?: {
  facility?: string;
  checkInWindowMinutes?: number;
}): number => {
  if (typeof booking?.checkInWindowMinutes === 'number') {
    return booking.checkInWindowMinutes * 60 * 1000;
  }
  return (
    FALLBACK_WINDOW_MS_BY_FACILITY[booking?.facility ?? ''] ??
    CHECK_IN_WINDOW_MS
  );
};
